// extracted by mini-css-extract-plugin
export default {"wrapper":"_f60a17ec"};